import { AuthApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { LocalStorage } from '../../../util/LocalStorage';
import { useNavigate } from 'react-router';
import { useAddAuth } from '../useAddAuth';
import useHttpPostSendVerificationCode from './useHttpPostSendVerificationCode';
import { useJoinToken } from '../useJoinToken';
import { useTranslation } from '../../useTranslation';
import { AppError, ErrorCodes, isErrorCode, getUserMessage } from '../../../api/utils/ErrorHandler';

interface SignInValues {
    username: string;
    password: string;
}

const useHttpPostSignIn = () => {
    const { t } = useTranslation('auth');
    const authApi: AuthApi = useContainer(AuthApi);
    const storage: LocalStorage = useContainer(LocalStorage);
    const navigate = useNavigate();
    const toastHandler = useContainer(ToastStateHandler);
    const { addUserAuth } = useAddAuth();
    const { exec: resendConfirmationCode } = useHttpPostSendVerificationCode();

    const { getJoinTokenAsQuery } = useJoinToken();

    const exec = (signIn: SignInValues) => {
        const { exec, clearCache, abort } = authApi.signIn({
            body: {
                ...signIn,
            },
            onSuccess: res => {
                storage.setAuth(res.body.tokens);
                addUserAuth(res.body.user);
                clearCache();
            },
            onError: (error: AppError | string) => {
                if (typeof error === 'object' && isErrorCode(error, ErrorCodes.USER_NOT_CONFIRMED)) {
                    resendConfirmationCode(signIn.username);
                    navigate(`/auth/verification?email=${signIn.username}${getJoinTokenAsQuery(false)}`);
                } else {
                    const message = typeof error === 'object' ? getUserMessage(error, t('signInError')) : t('signInError');
                    toastHandler.push('error', 'Sing In', message);
                }
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPostSignIn;
